import React, { useState } from 'react';
import styles from './CardEventSearch.module.scss';
import Icon from '../Icon';

const CardEventSearch = ({ title, text, href }) => {
    const [isVisible, setIsVisible] = useState(true);

    const handleClose = () => {
        setIsVisible(false);
    };

    if (!isVisible) {
        return null;
    }

    return (
        <div className={styles['CardEventSearch']}>
            <div className={styles['CardEventSearch__Container']}>
                <a
                    href={href}
                    className={styles['CardEventSearch__TitleWrapper']}>
                    <h2 className={styles['CardEventSearch__Title']}>
                        {title}
                        <Icon type="arrow" color="black" size="large" />
                    </h2>
                </a>
                <div className={styles['CardEventSearch__Content']}>
                    <p className={styles['CardEventSearch__Text']}>{text}</p>
                </div>
                <button
                    className={styles['CardEventSearch__Close']}
                    onClick={handleClose}>
                    <Icon type="close" color="black" size="small" />
                </button>
            </div>
        </div>
    );
};

CardEventSearch.propTypes = {};

export default CardEventSearch;
